var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.78869 8.70121V2.21401C9.78869 1.92726 9.67478 1.65225 9.47201 1.44949C9.26925 1.24672 8.99424 1.13281 8.70749 1.13281H1.67969",
    stroke: "#111D31",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.83735 10.8636H10.3245C10.6113 10.8636 10.8863 10.7497 11.0891 10.5469C11.2918 10.3442 11.4058 10.0692 11.4058 9.78241V9.24181C11.4058 9.09844 11.3488 8.96093 11.2474 8.85955C11.146 8.75817 11.0085 8.70121 10.8652 8.70121H5.45915C5.31577 8.70121 5.17827 8.75817 5.07689 8.85955C4.97551 8.96093 4.91855 9.09844 4.91855 9.24181V9.78241C4.91855 10.0692 4.80464 10.3442 4.60187 10.5469C4.39911 10.7497 4.1241 10.8636 3.83735 10.8636ZM3.83735 10.8636C3.5506 10.8636 3.27559 10.7497 3.07283 10.5469C2.87006 10.3442 2.75615 10.0692 2.75615 9.78241V2.21401C2.75615 1.92726 2.64224 1.65225 2.43947 1.44949C2.23671 1.24672 1.9617 1.13281 1.67495 1.13281C1.3882 1.13281 1.11319 1.24672 0.910426 1.44949C0.707662 1.65225 0.59375 1.92726 0.59375 2.21401V3.29521C0.59375 3.43859 0.650706 3.57609 0.752088 3.67747C0.85347 3.77886 0.990974 3.83581 1.13435 3.83581H2.75615",
    stroke: "#111D31",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.9375 3.5H4.4375",
    stroke: "#111D31",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.9375 5.5H4.4375",
    stroke: "#111D31",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.38349a929cc6d0565f145d18ef88a88e.svg";
export { ForwardRef as ReactComponent };